<template>
  <div class="file-up">
    <van-uploader
      v-model="files"
      :before-read="beforeRead"
      :after-read="afterRead"
      :before-delete="beforeDelete"
      accept="image/*,.pdf,.zip,.doc,.docx,.ppt,.txt,.xls,.xlsx,.ofd"
    >
      <div class="upload-item-wrap">
        <span class="iconfont">{{'\ue61f'}}</span>
      </div>
      <template #preview-cover="{ file }">
        <div class="preview-cover van-ellipsis">{{ file }}</div>
      </template>
    </van-uploader>
  </div>
</template>
<script>
import { Uploader } from 'vant'
import UploadService from '@services/UploadService'
export default {
  props: {
    fileList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    fileList (v) {
      this.files = v
    }
  },
  mounted () {
    this.files = this.fileList
  },
  data () {
    return {
      files: []
    }
  },
  components: {
    [Uploader.name]: Uploader
  },
  methods: {
    beforeRead (file) {
      return true
    },
    afterRead (file) {
      file.status = 'uploading'
      file.message = '上传中...'
      UploadService(file.file, this.functionPoint).then(data => {
        if (data.code === '200') {
          this.$emit('finishUpload', data, file)
          file.status = 'done'
          file.message = '上传成功'
        } else {
          file.status = 'failed'
          file.message = data.message
          this.$emit('finishUpload', {
            success: false,
            ...data
          })
        }
        this.fileListInside = []
      }).catch(e => {
        this.fileListInside = []
        file.status = 'failed'
        file.message = e
        this.$props.finishUpload && this.$props.finishUpload({ success: false, ...e })
      })
    },
    beforeDelete (file) {
      this.$emit('beforeDelete', file)
    }
  }
}
</script>
<style scoped lang="less">
.file-up{
  margin-top: 16px;
  width: 100%;
  /deep/.van-uploader__input{
    width: 160px;
    height: 160px;
  }
  /deep/.van-uploader__upload{
    width: 160px;
    height: 160px;
    background: #fff;
  }
  .upload-item-wrap {
  width:160px;
  height:160px;
  background-color: #fff;
  border-radius:4px;
  font-weight: 100;
  color: #9EA9B9;
  .iconfont {
    display: block;
    text-align: center;
    height: 150px;
    line-height: 150px;
  }
}
/deep/.van-uploader__wrapper{
  width: 100%;
  display: flex;
  align-items: center;
}
/deep/.van-uploader__file{
  width: 100%;
  height: 100%;
}
/deep/.van-uploader__preview{
  width: 150px !important;
  height: 150px !important;
  margin-right: 24px;
}
/deep/.van-image{
  width: 150px !important;
  height: 150px !important;
}
}
</style>
